import { ReactNode, SyntheticEvent } from "react";

import Icon from "../Icon";

import * as styledElements from "./CircleBadgeStyles";

import { ButtonVariants } from "../Button/constants";

interface IconProps {
  src: string;
  alt: string;
  iconDimension?: number;
}

const CircleBadge = ({
  styleProps,
  isLink = true,
  text,
  hasBottomConnector = false,
  type = ButtonVariants.SECONDARY,
  bottomConnectorVariant,
  iconProps,
  onClick,
  disabled = false,
  children = null,
}: {
  styleProps?: object;
  isLink?: boolean;
  text?: string;
  hasBottomConnector?: boolean;
  type?: ButtonVariants;
  bottomConnectorVariant?: string;
  iconProps?: IconProps;
  onClick?: (event?: SyntheticEvent) => void;
  disabled?: boolean;
  children?: ReactNode;
}) => {
  const isPrimary = type == ButtonVariants.PRIMARY;
  return (
    <styledElements.Container
      style={styleProps}
      isLink={isLink}
      isPrimary={isPrimary}
      smallSize={!!text}
      onClick={!disabled ? onClick : undefined}
    >
      {iconProps && (
        <Icon
          src={iconProps.src}
          alt={iconProps.alt}
          iconDimension={iconProps.iconDimension}
        />
      )}
      {text && <>{text}</>}
      {children}
      {hasBottomConnector && (
        <styledElements.VerticalLine
          isPrimary={
            bottomConnectorVariant
              ? bottomConnectorVariant == "primary"
              : isPrimary
          }
        />
      )}
    </styledElements.Container>
  );
};

export default CircleBadge;
